export default "__VITE_ASSET__ff5d3eb1__"